import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
import { PURCHASE_ORDER_CONSTRAINTS } from './constraints.js';
import { purchaseOrderQuantitySchema } from './item-quantity.js';
import { purchaseOrderUnitCostBoundsSchema } from './item-unit-cost.js';
export const purchaseOrderItemUnitCostSchema = z
    .number({
    error: (issue) => typeof issue.input === 'number' && !Number.isFinite(issue.input)
        ? `${PURCHASE_ORDER_CONSTRAINTS.unitCost.label} must be a finite number.`
        : undefined,
})
    .pipe(purchaseOrderUnitCostBoundsSchema);
export const purchaseOrderItemTaxRateSchema = z
    .number()
    .min(0, `${PURCHASE_ORDER_CONSTRAINTS.taxRate.label} must be 0 or greater.`)
    .max(100, `${PURCHASE_ORDER_CONSTRAINTS.taxRate.label} must be 100 or less.`);
export const addPurchaseOrderItemInputSchema = z.object({
    partId: requiredUuidString(`${PURCHASE_ORDER_CONSTRAINTS.part.label} is required.`, 'Invalid part selection.'),
    quantity: purchaseOrderQuantitySchema,
    unitCost: purchaseOrderItemUnitCostSchema.optional().nullable(),
    taxRate: purchaseOrderItemTaxRateSchema.optional().nullable(),
});
export const updatePurchaseOrderItemInputSchema = z
    .object({
    // GraphQL optional floats are nullable; treat explicit null as "omit" for quantity.
    quantity: z.preprocess((value) => (value === null ? undefined : value), purchaseOrderQuantitySchema.optional()),
    unitCost: purchaseOrderItemUnitCostSchema.optional().nullable(),
    taxRate: purchaseOrderItemTaxRateSchema.optional().nullable(),
})
    .refine((value) => value.quantity !== undefined || value.unitCost !== undefined || value.taxRate !== undefined, 'At least one line field must be provided.');
//# sourceMappingURL=item-input.js.map